export const ResponsiveVideo = (function () {
    'use strict';

    function init() {
        const videoEls = document.querySelectorAll('[data-responsive-video]')
        const videos = []

        const getWidth = (url) => {
            const test = url.trim().match(/-(\d{2,4}).mp4$/i)
            return test ? parseInt(test[1]) : 5000
        }

        videoEls.forEach((el) => {
            const urls = el.getAttribute('data-responsive-video').split(',')
            const video = { el, active: false, urls: [] }
            urls.forEach((url) => {
                video.urls.push({
                    width: getWidth(url),
                    url: url.trim(),
                })
            })
            video.urls.sort((a, b) => { return b.width - a.width })
            videos.push(video)
        })

        const onResize = () => {
            const winWidth = window.innerWidth
            videos.forEach((video) => {
                let url = video.urls[0].url
                video.urls.forEach((src) => {
                    if (src.width > winWidth) {
                        url = src.url
                    }
                })
                if (url !== video.active) {
                    video.active = url
                    video.el.innerHTML = `<source src="${url}" type="video/mp4">`
                    video.el.load()
                    // console.log('video src set', url)
                }
            })
        }

        window.addEventListener('resize', onResize, { capture: true, passive: true })
        onResize()
    }


    return {
        init: init,
    };
})();
